import {user_data_fixture} from './user_data';

import {createResponseList} from '../utils';

import {AuthenticatedUserSerializedType, UserSerializedType} from 'sweet-types';

let currentId = 0;

const createFakeUserFromAuthenticatedUser = ({
  id,
  name,
  emailstatus,
  is_deleted,
  timezone,
  is_manager,
  is_super_manager,
  is_email_verified,
  avatar_image,
  is_super_teammate,
  team_memberships,
  teams,
  html_url,
  url,
  is_guest_until,
  email,
  emailaddresses,
  is_two_factor,
  is_billing_admin,
  restrict_saml_only_login,
}: AuthenticatedUserSerializedType): UserSerializedType => {
  return {
    id,
    name,
    emailstatus,
    is_deleted,
    timezone,
    is_manager,
    is_super_manager,
    is_email_verified,
    avatar_image,
    is_super_teammate,
    team_memberships: [...team_memberships],
    teams: [...teams],
    html_url,
    url,
    is_guest_until,
    email,
    emailaddresses: [...emailaddresses],
    is_two_factor,
    is_billing_admin,
    restrict_saml_only_login,
    content_type: 'user',
    can_edit: false,
    is_active: true,
    is_account_only: false,
    is_saml_account: false,
  };
};
export const createFakeUser = (
  name: string,
  email: string
): UserSerializedType => {
  return {
    id: ++currentId,
    name,
    emailstatus: null,
    is_deleted: false,
    timezone: 'America/Sao_Paulo',
    is_manager: false,
    is_super_manager: false,
    is_email_verified: false,
    avatar_image: null,
    is_super_teammate: false,
    team_memberships: [],
    teams: [],
    html_url: `/people/user/${currentId}/`,
    url: `/api/v1/users/${currentId}/`,
    is_guest_until: null,
    email,
    emailaddresses: [],
    is_two_factor: false,
    is_billing_admin: false,
    restrict_saml_only_login: false,

    content_type: 'user',
    can_edit: false,
    is_active: true,
    is_account_only: false,
    is_saml_account: false,
  };
};

export const user_list_fixture = createResponseList<UserSerializedType>([
  createFakeUserFromAuthenticatedUser(user_data_fixture),
]);
